export const januaryAbbreviatedLowercase = "_qa";
export default {januaryAbbreviatedLowercase};